import api from '@/libs/api'
import store from '@/store'

const projectId = () => store.state.app.projectId

export default {
  namespaced: true,
  state: {
    lens: {},
    gettingLens: false,
    timeLens: [],
    gettingTimeLens: false,
    gettingRgwLens: false,
    rgwLens: [],
    gettingRgwCategories: false,
    rgwCategories: [],
  },
  mutations: {
    SET_LENS(state, value) {
      state.lens = value
    },
    SET_GETTING_LENS(state, value) {
      state.gettingLens = value
    },
    SET_GETTING_TIME_LENS(state, value) {
      state.gettingTimeLens = value
    },
    SET_TIME_LENS(state, value) {
      state.timeLens = value.reverse()
    },
    SET_GETTING_RGW_LENS(state, value) {
      state.gettingRgwLens = value
    },
    SET_RGW_LENS(state, value) {
      state.rgwLens = value
    },
    SET_GETTING_RGW_CATEGORIES(state, value) {
      state.gettingRgwCategories = value
    },
    SET_RGW_CATEGORIES(state, value) {
      state.rgwCategories = value
    },
  },
  actions: {
    getLens({ commit }) {
      commit('SET_GETTING_LENS', true)
      return new Promise((resolve, reject) => {
        api('storage').get(`/v1/projects/${projectId()}/lens`)
          .then(response => {
            commit('SET_LENS', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_GETTING_LENS', false) })
      })
    },
    getTimeLens({ commit }, payload) {
      commit('SET_GETTING_TIME_LENS', true)
      let url = `/v1/projects/${projectId()}/time-lens?Period=${payload.period}`
      if (payload.usage) {
        url += `&UsageType=${payload.usage}`
      }
      if (payload.bucket) {
        url += `&Bucket=${payload.bucket}`
      }
      return new Promise((resolve, reject) => {
        api('storage').get(url)
          .then(response => {
            commit('SET_TIME_LENS', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_GETTING_TIME_LENS', false) })
      })
    },
    getRgwLens({ commit }, payload) {
      commit('SET_GETTING_RGW_LENS', true)
      let url = `/v1/projects/${projectId()}/rgw-lens?Period=${payload.period}`
      if (payload.category) {
        url += `&Category=${payload.category}`
      }
      if (payload.bucket) {
        url += `&Bucket=${payload.bucket}`
      }
      return new Promise((resolve, reject) => {
        api('storage').get(url)
          .then(response => {
            commit('SET_RGW_LENS', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_GETTING_RGW_LENS', false) })
      })
    },
    getRgwCategories({ commit }, payload) {
      commit('SET_GETTING_RGW_CATEGORIES', true)
      let url = `/v1/projects/${projectId()}/rgw-categories?Period=${payload.period}`
      if (payload.category) {
        url += `&Category=${payload.category}`
      }
      if (payload.bucket) {
        url += `&Bucket=${payload.bucket}`
      }
      return new Promise((resolve, reject) => {
        api('storage').get(url)
          .then(response => {
            commit('SET_RGW_CATEGORIES', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_GETTING_RGW_CATEGORIES', false) })
      })
    },
  },
}
